<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.userCategory.query.name')" prop="name">
                <a-input v-model="queryParam.name" :placeholder="$t('views.userCategory.query.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="排序" prop="sort">-->
<!--                  <a-input v-model="queryParam.sort" placeholder="请输入排序" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.userCategory.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.userCategory.btn.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button v-hasPermi="['user:category:add']" type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />{{ $t('views.userCategory.btn.add') }}
        </a-button>
        <a-button v-hasPermi="['user:category:edit']" type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />{{ $t('views.userCategory.btn.edit') }}
        </a-button>
        <a-button v-hasPermi="['user:category:remove']" type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />{{ $t('views.userCategory.btn.delete') }}
        </a-button>
        <table-setting
          :key="$i18n.locale"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            :disabled="!canEdit"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            :disabled="!canEdit"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" />
          <a v-hasPermi="['user:category:edit']" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('views.userCategory.btn.edit') }}
          </a>
          <a-divider type="vertical" />
          <a v-hasPermi="['user:category:remove']" @click="handleDelete(record)">
            <a-icon type="delete" />{{ $t('views.userCategory.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCategory, delCategory, updateCategorySort, updateCategoryStatus } from '@/api/user/category'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import auth from '@/plugins/auth'

export default {
  name: 'Category',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        icon: null,
        description: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  filters: {
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  computed: {
    canEdit () {
      return auth.hasPermi('user:category:edit')
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    paginationShowTotal (total) {
      return this.$t('views.userCategory.pagination.total', { total })
    },
    buildColumns () {
      this.columns = [
        {
          title: this.$t('views.userCategory.column.id'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.userCategory.column.name'),
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.userCategory.column.nameEn'),
          dataIndex: 'nameEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.userCategory.column.sort'),
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.userCategory.column.status'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.userCategory.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.userCategory.column.operation'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    /** 查询产品分类列表 */
    getList () {
      this.loading = true
     pageCategory(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        icon: undefined,
        description: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: that.$t('views.userCategory.confirm.deleteTitle'),
        content: that.$t('views.userCategory.confirm.deleteContent', { ids }),
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id }))
          return delCategory(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.userCategory.msg.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: that.$t('views.userCategory.confirm.exportTitle'),
        content: that.$t('views.userCategory.confirm.exportContent'),
        onOk () {
          that.download('user/category/export', {
            ...that.queryParam
          }, that.$t('views.userCategory.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      if (!this.canEdit) {
        return
      }
      const statusValue = checked ? 1 : 0
      updateCategoryStatus({ id: record.id, status: statusValue }).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.userCategory.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.userCategory.msg.statusFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (!this.canEdit) {
        return
      }
      if (value === null || value === undefined) {
        return
      }
      updateCategorySort({ id: record.id, sort: value }).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.userCategory.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.userCategory.msg.sortFail'))
      })
    }
  }
}
</script>
